var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTravelRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.8V12H12V0H2C0.9 0 0 0.8 0 1.8Z",
    fill: "#465867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V24H2C0.9 24 0 23.2 0 22.2V12H12Z",
    fill: "#FF7300"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.77467,
    width: 13.7406,
    height: 16.8453,
    rx: 1.5,
    fill: "#E8E8E8",
    stroke: "#465867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9893 3.58893C23.0811 4.27447 22.5695 4.92262 21.8773 5.11518C21.0777 5.33764 20.1624 5.57004 19.2235 5.79676C18.8465 6.50654 18.451 7.19244 18.1554 7.69187C17.8825 8.15286 17.3094 8.42717 16.7721 8.36446C16.1579 8.29276 15.7835 7.80461 15.922 7.24335C15.9762 7.02375 16.038 6.77778 16.1055 6.51597C15.1088 6.73701 14.2149 6.92801 13.5592 7.06598C12.9866 7.18648 12.4529 6.86551 12.3017 6.33991C12.2901 6.31304 12.2799 6.28518 12.2712 6.25639C12.0499 5.51987 11.8535 4.61695 11.7207 3.94902C11.6125 3.40423 11.943 2.85674 12.4844 2.66089C13.0259 2.46504 13.6165 2.67935 13.8632 3.17408C14.0327 3.51417 14.2316 3.92479 14.422 4.34633C15.9804 3.68713 18.088 2.82521 19.9282 2.17457C21.2868 1.69422 22.8057 2.21786 22.9893 3.58893Z",
    fill: "#FFF0E1",
    stroke: "#FF7300",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03167 11.0362C9.10979 11.1143 9.24261 11.1143 9.32073 11.0362L11.6176 8.73929C11.6957 8.66116 11.6957 8.52835 11.6176 8.45023L11.3364 8.16898C11.2582 8.09085 11.1332 8.09085 11.0551 8.16898L9.18011 10.044L8.29729 9.16898C8.21917 9.09085 8.09417 9.09085 8.01604 9.16898L7.73479 9.45023C7.65667 9.52835 7.65667 9.66116 7.73479 9.73929L9.03167 11.0362Z",
    fill: "#F47B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03167 16.1348C9.10979 16.213 9.24261 16.213 9.32073 16.1348L11.6176 13.838C11.6957 13.7598 11.6957 13.627 11.6176 13.5489L11.3364 13.2676C11.2582 13.1895 11.1332 13.1895 11.0551 13.2676L9.18011 15.1426L8.29729 14.2676C8.21917 14.1895 8.09417 14.1895 8.01604 14.2676L7.73479 14.5489C7.65667 14.627 7.65667 14.7598 7.73479 14.838L9.03167 16.1348Z",
    fill: "#F47B20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTravelRequests);
export default __webpack_public_path__ + "static/media/myTravelRequests.617bc194f34e0d3a62fd7299622759f2.svg";
export { ForwardRef as ReactComponent };